export default {
    inject: ['container'],
    computed: {
        queues () {
            return this.container.queues
        }
    }
}
